import { action, makeObservable, observable, reaction } from "mobx";
import { ServiceTypeWithAppointmentTypes } from "../types/servicetypewithappointmenttypes";
import { AppointmentType } from "../types/appointmenttype";
import { sessionManager } from "../managers/SessionManager";

class AppointmentTypesStore {

    @observable serviceTypesWithAppointmentTypes: ServiceTypeWithAppointmentTypes[] | undefined = undefined;
    @observable selectedAptType: AppointmentType | undefined = undefined;

    constructor() {
        makeObservable(this)

        reaction(
            () => this.selectedAptType,
            (newAppointmentType) => {
                sessionManager.updateDoctorsForAppointmentType(newAppointmentType);
            }
        );
    }

    @action
    setServiceTypesWithAppointmentTypes = (serviceTypesWithAppointmentTypes: ServiceTypeWithAppointmentTypes[]) => {
        this.serviceTypesWithAppointmentTypes = serviceTypesWithAppointmentTypes;
    }

    @action
    setSelectedAptType = (selectedAptType: AppointmentType) => {
        this.selectedAptType = selectedAptType;
    }

}

export const appointmentTypesStore = new AppointmentTypesStore();